import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { BurdDeliveryLeftTime } from '@models/api-orders.models';
import { HttpClient } from '@angular/common/http';
import { BurdResponse } from '@features/checkout/checkout-delivery-burd/checkout-delivery-burd.models';
import { StorageService } from '@core/services/storage.service';

@Injectable({
    providedIn: 'root'
})
export class BurdSameDayDeliveryService {
    private readonly activeSameDayDeliveryKey: string = 'active-same-day-delivery';
    private readonly sameDayDeliveryZipCodeKey: string = 'same-day-delivery-zip-code';

    private sameDayDeliveryStateRS: ReplaySubject<boolean> = new ReplaySubject(1);

    public sameDayDeliveryState: Observable<boolean> = this.sameDayDeliveryStateRS.asObservable();

    constructor(private http: HttpClient, private storageService: StorageService) {}

    public getBurdDeliveryTimeLeft(): Observable<BurdDeliveryLeftTime> {
        return this.http.get<BurdDeliveryLeftTime>(`orders-ms/deliveryoptions/burddelivery/timeleft`);
    }

    public getBurdZipApproval(zip: string): Observable<BurdResponse> {
        return this.http.get<BurdResponse>(`orders-ms/deliveryoptions/burdavailability/${zip}`);
    }

    public setSameDayDelivery(state: boolean): void {
        this.storageService.set(this.activeSameDayDeliveryKey, state, { sessionOnly: true });
        this.sameDayDeliveryStateRS.next(state);
    }

    public setSameDayDeliveryZipCode(zipCode: string): void {
        this.storageService.set(this.sameDayDeliveryZipCodeKey, zipCode, { sessionOnly: true });
    }

    public getSameDayDeliveryZipCode(): string {
        return this.storageService.get(this.sameDayDeliveryZipCodeKey) || '';
    }
}
